// DO NOT EDIT THIS FILE. It should be automatically generated by running
// pnpm generate-product-schemas
import { format } from 'date-fns/format'
import * as z from 'zod'

import * as constants from '@nxt-insurance/constants'

// This is the base schema that can be extended when using it in configs
export const BaseSchema_BikeTheftV1LukoToGetsafeDe = z.object({
  has_gps: z.boolean(),
  zip_code: z.string().min(1).optional(),
  bike_type: z.enum(['bike', 'e_bike']),
  bike_price: z
    .preprocess((val) => {
      if (val === '' || val === undefined) {
        return undefined
      }
      return Number(val)
    }, z.number().int().gte(100).lte(10_000))
    .optional(),
  ebike_price: z
    .preprocess((val) => {
      if (val === '' || val === undefined) {
        return undefined
      }
      return Number(val)
    }, z.number().int().gte(1000).lte(10_000))
    .optional(),
  tariff_type: z.enum(['theft', 'theft_and_kasko']),
  frame_number: z.string().optional(),
  kasko_coverage: z.boolean(),
  date_of_purchase: z
    .union([z.number(), z.string(), z.date()])
    .pipe(z.coerce.date())
    .transform((value) => {
      return format(value, constants.SERVER_DATE_FORMAT)
    })
    .optional(),
})

const Schema_BikeTheftV1LukoToGetsafeDe = BaseSchema_BikeTheftV1LukoToGetsafeDe.superRefine(
  (values, ctx) => {
    if (values['bike_type'] !== undefined && ['bike'].includes(values['bike_type'])) {
      if (values['bike_price'] === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_type,
          expected: 'integer',
          received: 'undefined',
          message: 'Required',
          path: ['bike_price'],
        })
      }
    }
  }
).superRefine((values, ctx) => {
  if (values['bike_type'] !== undefined && ['e_bike'].includes(values['bike_type'])) {
    if (values['ebike_price'] === undefined) {
      ctx.addIssue({
        code: z.ZodIssueCode.invalid_type,
        expected: 'integer',
        received: 'undefined',
        message: 'Required',
        path: ['ebike_price'],
      })
    }
  }
})

export default Schema_BikeTheftV1LukoToGetsafeDe
